<template>
    <el-dropdown-item @click="redirect">
        <slot name="icon"></slot>
        {{ name }}
    </el-dropdown-item>
</template>

<script lang="ts">
    import { useRouter } from "vue-router";

    import tableFilter from "./tableFilter";

    class genericClass {
        [index: string]: any;
    }

    export default {
        props: {
            name: {
                type: String,
                default: () => {
                    return '';
                }
            },
            route: {
                type: String,
                default: () => {
                    return '';
                }
            },
            tableName: {
                type: String,
                default: () => {
                    return '';
                }
            },
            filters: {
                type: tableFilter,
                default: () => {
                    return new tableFilter();
                }
            },
            params: {
                type: genericClass,
                default: () => {
                    return new genericClass();
                }
            }
        },

        setup(props) {
            const router = useRouter();

            const redirect = () => {
                if (props.filters) {
                    let values = window.localStorage.getItem(`${props.tableName.replace(/ /gi, '_')}-TableFilters`);
                    if (values)
                        window.localStorage.removeItem(`${props.tableName.replace(/ /gi, '_')}-TableFilters`);

                    let filters = props.filters as tableFilter;

                    window.localStorage.setItem(`${props.tableName.replace(/ /gi, '_')}-TableFilters`, filters.stringfy());
                }

                let rota: any = { name: props.route };

                if (props.params) {
                    rota.params = props.params;
                }
                router.push(rota);
            }

            return {
                redirect
            }
        },
    };

</script>

<style>
</style>